import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { devWarn } from "../lib/logger";
import { ScrollText } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { renderAnswerBlocks } from "../lib/safeHtml";

const History = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/numerology/history");
        setItems(data.items);
      } catch (err) {
        devWarn("Failed to load history", err);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-8 sm:py-12">
      <div className="mb-8 sm:mb-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-3">Archive</p>
          <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tighter">Your readings</h1>
        </div>
        <Link to="/ask" className="self-start">
          <Button className="rounded-full bg-gold text-black hover:bg-[#F3E5AB] transition-colors duration-200" data-testid="new-reading-btn">
            New reading
          </Button>
        </Link>
      </div>

      {loading ? (
        <div className="text-center py-16 text-neutral-500">Gathering the scrolls…</div>
      ) : items.length === 0 ? (
        <div className="rounded-2xl border border-white/5 bg-[#141419] p-12 text-center">
          <ScrollText className="mx-auto h-8 w-8 text-neutral-600 mb-4" />
          <p className="text-neutral-400">No readings yet.</p>
          <Link to="/ask" className="text-gold hover:underline mt-2 inline-block" data-testid="empty-cta">
            Ask your first question →
          </Link>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((it) => (
            <div
              key={it.reading_id}
              className="rounded-2xl border border-white/5 bg-[#141419] hover:border-white/15 transition-colors duration-200"
              data-testid={`reading-item-${it.reading_id}`}
            >
              <button
                onClick={() => setOpen(open === it.reading_id ? null : it.reading_id)}
                className="w-full text-left p-5 sm:p-6"
              >
                <div className="flex items-start justify-between gap-4 sm:gap-6">
                  <div className="flex-1 min-w-0">
                    <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-2">
                      {new Date(it.created_at).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })}
                    </div>
                    <div className="font-serif text-lg sm:text-xl text-white leading-snug break-words">{it.question}</div>
                  </div>
                  <div className="text-xs text-gold border border-gold/30 rounded-full px-3 py-1 shrink-0">
                    {it.cost} cr
                  </div>
                </div>
              </button>
              {open === it.reading_id && (
                <div className="border-t border-white/5 p-5 sm:p-6 pt-5 reading-content whitespace-pre-line" data-testid="reading-body">
                  {renderAnswerBlocks(it.answer).map(({ key, __html }) => (
                    <p key={key} dangerouslySetInnerHTML={{ __html }} />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default History;
